<template>
  <div class="approve-fail-list">
    <Modal
      v-model="show"
      :footer-hide="true"
      :closable="false"
      :width="800"
      title="财务确认审批操作"
    >
      <div class="main" style="margin-bottom: 56px">
        <p style="margin-bottom: 16px">
          ①审批即表示对本次教师考勤的确认单确认无误，请根据实际情况进行审批操作。如果设置成通过，该操作<span
            class="font-bold"
            >不可恢复</span
          >，是否确认该操作？
        </p>
        <p>请输入{{ phoneNo | fliterPhone }}收到的验证码，进行确证操作。</p>
        <div class="input-main">
          <Input
            v-model="phoneCode"
            placeholder="请输入短信验证码"
            style="width: 300px"
          />
          <p class="msg-text" @click="handleSend">{{ msgText }}</p>
        </div>
        <p class="msg-error">{{ errorStr }}</p>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleCancle">取消</Button>
        <Button type="error" @click="handleFail(4)">审批驳回</Button>
        <Button type="primary" @click="handleSubmit(3)">审批通过</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import financeCenterApi from '@/request/financeCenter/index.js'
import common from '@/request/common/index';
import { fliterPhone } from '@/utils/utils';
export default {
  components: {

  },
  props: {
    cfmCountNum: {
      type: Object,
      default: () => {
        return {
          abolishNum: 0,
          confirmedNum: 0,
          schoolConfirmNum: 0,
          unconfirmedNum: 0
        }
      }
    },
    sheetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      success: 0,
      failure: 0,
      phoneNo: '',
      phoneCode: '',
      msgText: '获取验证码',
      errorStr: '',
      credential: ''
    }
  },
  mounted() {

  },
  methods: {
    handleShow() {
      this.show = true
      this.msgText = '获取验证码'
      this.phoneCode = ''
      this.errorStr = ''
      this.getUserPhone()
    },
    handleCancle() {
      this.show = false
    },
    handleSubmit(sheetSts) {
      this.setFinancialConfirmed(sheetSts)
    },
    // 驳回
    handleFail(sheetSts) {
      this.setFinancialConfirmed(sheetSts)
    },
    async handleSend() {
      if (this.msgText != '获取验证码') {
        return null;
      }
      this.credential = await this.sendMsg()
      let second = 60;
      this.msgText = `${second}s后获取`;
      this.timer = setInterval(() => {
        if (second == 0) {
          clearInterval(this.timer);
          this.msgText = "获取验证码";
          return false;
        }
        second--;
        this.msgText = `${second}s后获取`;
      }, 1000);
    },
    async sendMsg() {
      return new Promise(async resolve => {
        let res = await common.sendPCMsg({

        });
        if (res.status == 200) {
          this.$Message.success("发送成功，请注意查收");
          resolve(res.message);
        }
      });
    },
    // 获取用户的手机号
    async getUserPhone() {
      const res = await common.getUserInfoApi();
      if (res.status === 200) {
        this.phoneNo = res.message.phone;
      }
    },
    async setFinancialConfirmed(sheetSts) {
      if (!this.phoneCode) {
        return this.$Message.warning('请输入短信验证码');
      }
      this.$Spin.show();
      let res = await financeCenterApi.setFinancialConfirmedApi({ sheetId: this.sheetId, verifyCode: this.phoneCode, sheetSts: sheetSts, credential: this.credential })
      this.$Spin.hide();
      if (res.status == 200) {
        this.show = false
        this.$Message.success('操作成功');
        this.$emit('on-finish')
      }
    }
  },
  filters: {
    fliterPhone(phone) {
      if (phone) {
        return fliterPhone(phone);
      } else {
        return '--';
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.input-main {
  padding: 16px 0;
  position: relative;
  width: 300px;
  .msg-text {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #6149f1;
    cursor: pointer;
  }
}
.msg-error {
  color: red;
}
</style>